import React from 'react'
import injectSheet from 'react-jss'
import styles from './guide.styles'
import classNames from 'classnames'

const Guide = ({ classes, className, style }) => (
  <div style={style} className={classNames(classes.container, className)}>
    <div className={classes.box} />
    <div className={classes.box} />
    <div className={classes.box} />
  </div>
)

export default injectSheet(styles)(Guide)
